import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { Radio } from "../../../../components/radio";
import { Error } from "../../../../components/error";
import { MANDATORY_SURVEY, OPTIONAL_SURVEY } from "../../../../constants/surveyTypes";
import { updatePerson } from "../../../../api/secureApi";
import { adjustState } from "./utils";
import { handleError } from "../../../../utils/handleError";
import { useState } from "react";

export function Employed() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [genericErrorMessage, setGenericErrorMessage] = useState("");

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "all" });

  const onSubmit = (data) => {
    const newState = { ...state, ...data };
    const currentMandatorySurvey = state.surveys.find((survey) => survey.type === MANDATORY_SURVEY);
    let currentOptionalSurvey = state.surveys.find((survey) => survey.type === OPTIONAL_SURVEY);
    if (currentOptionalSurvey) {
      currentOptionalSurvey.answers.employed = data.employed;
    } else {
      currentOptionalSurvey = {
        type: OPTIONAL_SURVEY,
        answers: {
          employed: data.employed,
        },
      };
    }
    const stateToSubmit = {
      profile_id: newState.profile_id,
      surveys: [currentOptionalSurvey, currentMandatorySurvey],
    };
    adjustState(state, stateToSubmit);
    // eslint-disable-next-line no-console
    console.log("stateToSubmit in employed", stateToSubmit);

    updatePerson(stateToSubmit)
      .then((response) => {
        // eslint-disable-next-line no-console
        console.log("response in employed", response);
        if (data.employed.startsWith("yes")) {
          navigate("/register/pay-rate", { state: response });
        } else {
          navigate("/register/industry-want", { state: response });
        }
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.log("error in ethn", error);
        handleError(error, setGenericErrorMessage, navigate);
      });
  };

  return (
    <>
      <section id="heading">
        <div className="container mx-auto mt-10 flex max-w-3xl flex-col px-4">
          <h2 className="font-serif text-xl">1. Are you currently employed?</h2>
        </div>
      </section>
      <section id="form">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="container mx-auto my-10 flex max-w-3xl flex-col px-4">
            <div className="pb-4">
              <Radio
                name="employed"
                answer="yes-fulltime"
                label="yes, full time"
                register={register}
                {...register("employed", { required: true })}
              />
              <Radio
                name="employed"
                answer="yes-parttime-21-32"
                label="yes, part time. 21 - 32 hrs / week"
                register={register}
                {...register("employed", { required: true })}
              />
              <Radio
                name="employed"
                answer="yes-parttime-11-20"
                label="yes, part time. 11 - 20 hrs / week"
                register={register}
                {...register("employed", { required: true })}
              />
              <Radio
                name="employed"
                answer="yes-parttime-1-10"
                label="yes, part time. 1 - 10 hrs / week"
                register={register}
                {...register("employed", { required: true })}
              />
              <Radio
                name="employed"
                answer="no"
                label="no"
                register={register}
                {...register("employed", { required: true })}
              />
              <Error errors={errors} name="employed" />
              {/*{errors.employed && (*/}
              {/*  <p className="mt-2 text-sm text-red-600" id="employed-error">*/}
              {/*    Answer is required.*/}
              {/*  </p>*/}
              {/*)}*/}
            </div>
            <div className="flex flex-col justify-center">
              {genericErrorMessage && (
                <div className="mb-2  text-center text-sm text-red-600" id="email-error">
                  {genericErrorMessage}
                </div>
              )}
              <button
                type="submit"
                className="mb-4 w-full rounded-full bg-rasapink px-24 py-4 text-sm font-bold text-white hover:shadow-xl"
              >
                next
              </button>
            </div>
          </div>
        </form>
      </section>
    </>
  );
}
